import AsignadorFuncionService from 'src/modules/asignadorFuncion/asignadorFuncionService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'ASIGNADORFUNCION_VIEW';

const asignadorFuncionViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: asignadorFuncionViewActions.FIND_STARTED,
      });

      const record = await AsignadorFuncionService.find(id);

      dispatch({
        type: asignadorFuncionViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: asignadorFuncionViewActions.FIND_ERROR,
      });

      getHistory().push('/asignador-funcion');
    }
  },
};

export default asignadorFuncionViewActions;
